import React, { useContext } from "react";
import styled from 'styled-components';

import UserIcon from "@components/UserIcon/UserIcon";
import { ListContext } from "@contexts/ListContext";
import { showLog, showLogNoTime } from "@libs/NwMoment";

const CreatedByText = styled.div`
  white-space: ${(props) => props.noWrap && 'nowrap'};
  ${(props) =>
    props.$textTransform ? `text-transform: ${props.$textTransform};` : ''}
`;

const CreatedBy = ({
    object,
    author,
    date,
    extra = 'created',
    hideAvatar = true,
    breaklines,
    textonly,
    short,
    hideTime,
    noWrap,
    hideAuthor,
    emptyText = '',
    noDiv,
    middleText,
    textTransform,
}) => {

    const { cachedList, cachedListLoaded } = useContext(ListContext)

    let userID = null
    let userName = ""
    let userCoverGuid = ""
    let letters = ""
    let datevalue = null

    if (author || date) {
        userID = author
        datevalue = date
    } else {
        if (object && (object.DateCreated || object.UserCreated)) {
            const { DateCreated, UserCreated } = object
            datevalue = DateCreated
            userID = UserCreated
        }
    }

    if (userID) {
        if (cachedListLoaded) {
            const user = cachedList.users.items.find(usr => usr.ID === userID)
            if (user) {
                userName = `${short ? "" : " by "}${user.Name}`
                if (user.Surname) {
                    userName += ` ${user.Surname[0]}`
                }
                userCoverGuid = user.CoverGuid
                letters = user.Name.toUpperCase()[0]
                if (user.Surname) {
                    letters += user.Surname.toUpperCase()[0]
                }
            } else {
                userName = "Unknown"
                letters = "??"
            }
        }
    }

    if (textTransform && userName) {
        if (!short && userName.startsWith(' by ')) {
            userName = ` by ${userName.slice(4).toLowerCase()}`;
        } else {
            userName = userName.toLowerCase();
        }
    }

    const getDateFormat = dv => (
        hideTime ? showLogNoTime(dv) : showLog(dv)
    )

    const mText = middleText ? middleText : (extra ? " on " : " • ")

    const getText = () => {
        if (short) {
            return (
                <>
                    {!hideAuthor && userName}
                    {!hideAuthor && datevalue ? ', ' : ''}
                    {datevalue ? getDateFormat(datevalue) : ''}
                </>
            )
        } else {
            if (textonly) {
                return (<>{extra}{!hideAuthor && `${userName}`}{breaklines && <br />}{datevalue ? `${mText}${getDateFormat(datevalue)}`: ""}</>)
            }
            return (<>{extra} {!hideAuthor && `${userName}`}{breaklines && <br />}{datevalue ? `${mText}${getDateFormat(datevalue)}`: ""}</>)
        }
    }

    const textWrapProps = { noWrap, $textTransform: textTransform };

    if (userName || datevalue) {
        if (textonly) {
            if (noDiv) {
                return textTransform ? (
                    <span style={{ textTransform }}>{getText()}</span>
                ) : (
                    <>{getText()}</>
                );
            } else {
                return <CreatedByText {...textWrapProps}>{getText()}</CreatedByText>;
            }
        } else {
            return (
                <CreatedByText className="created-by" {...textWrapProps}>
                    {hideAvatar || hideAuthor ? (
                        getText()
                    ) : (
                        <>
                            <UserIcon userId={userID} coverGuid={userCoverGuid} letters={letters} size="medium" />{' '}
                            {getText()}
                        </>
                    )}
                </CreatedByText>
            );
        }
    } else {
        if (textonly) {
            return textTransform ? (
                <span style={{ textTransform }}>{emptyText}</span>
            ) : (
                <>{emptyText}</>
            );
        } else {
            return (
                <div className="created-by" style={textTransform ? { textTransform } : undefined}>
                    {emptyText}
                </div>
            );
        }
    }
};

export default CreatedBy;
